import './CTASection.css'

const CTASection = () => {
  const scrollToContact = () => {
    window.location.href = 'mailto:info@janacode.com'
  }

  return (
    <section className="cta-section section">
      <div className="container">
        <div className="cta-content">
          <h2 className="cta-title">
            Ready to build something <span className="highlight-orange">great</span>?
          </h2>
          <p className="cta-subtitle">
            Whether you have a product idea or need a tech partner for scale — let's talk. 
            We turn vision into code.
          </p>
          <button className="cta-button" onClick={scrollToContact}>
            info@janacode.com +
          </button>
        </div>
      </div>
    </section>
  )
}

export default CTASection
